export default "__VITE_ASSET__CtGYZQ6A__"